export const user_logged_in = (user) => ({
    type: 'USER_LOGGED_IN',
    user: user
})

export const user_logged_out = () => ({
    type: 'USER_LOGGED_OUT'
})